import React, { ReactNode } from 'react';

import { Tooltip } from '@chakra-ui/react';

import Text from 'components/atom/Text/styles';

import { Container } from './styles';

interface IBoxInfoProps {
  label?: string;
  info?: string;
  hideBorder?: boolean;
  children?: ReactNode;
}

const BoxInfo: React.FC<IBoxInfoProps> = ({ label, info, hideBorder = false, children }) => (
  <Container hideBorder={hideBorder}>
    {!children && (
      <>
        <Text>{label}</Text>

        <div>
          <Tooltip label={info}>
            <Text weight="bold">{info}</Text>
          </Tooltip>
        </div>
      </>
    )}

    {children}
  </Container>
);

export default BoxInfo;
